import React, { useState } from 'react';
import { Button, Container, Row, Col } from 'react-bootstrap';
import Header from '../Header';
import Footer from '../Footer';

import { getApiUrl } from '../../services/apiService';

import PhotoAlbum from 'react-photo-album';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import Fullscreen from 'yet-another-react-lightbox/plugins/fullscreen';
import Slideshow from 'yet-another-react-lightbox/plugins/slideshow';
import Thumbnails from 'yet-another-react-lightbox/plugins/thumbnails';
import Zoom from 'yet-another-react-lightbox/plugins/zoom';
import "yet-another-react-lightbox/plugins/thumbnails.css";

// Dynamické určení URL k obrázkům
const baseUrl = getApiUrl(); // Vrátí "http://localhost:5000" nebo "https://api.mojedomena.cz"

// Příklad fotografií
const photos = [
    { src: `${baseUrl}/images/foto_1.webp`, width: 1792, height: 1024 },
    { src: `${baseUrl}/images/foto_2.webp`, width: 1792, height: 1024 },
    { src: `${baseUrl}/images/foto_3.webp`, width: 1792, height: 1024 },
    { src: `${baseUrl}/images/foto_4.webp`, width: 1792, height: 1024 },
    { src: `${baseUrl}/images/foto_5.webp`, width: 1024, height: 1024 },
    { src: `${baseUrl}/images/foto_6.webp`, width: 1024, height: 1024 },
    { src: `${baseUrl}/images/foto_7.webp`, width: 1792, height: 1024 },
    { src: `${baseUrl}/images/foto_8.webp`, width: 1792, height: 1024 },
];

const FotoGalerie = () => {
    const [index, setIndex] = useState(-1);

    return (
        <div>
            <Header />
            <Container className='mb-4'>
                <Row className='m-5 text-center'>
                    <Col>
                        <h1>Jak to u nás vypadá?</h1>
                    </Col>
                </Row>
                <Row>
                    <Col>
                        <PhotoAlbum photos={photos} layout="rows" targetRowHeight={250} onClick={({ index }) => setIndex(index)} />
                        <Lightbox
                            slides={photos.map(photo => ({ src: photo.src }))}
                            open={index >= 0}
                            index={index}
                            close={() => setIndex(-1)}
                            plugins={[Fullscreen, Slideshow, Thumbnails, Zoom]}
                        />
                    </Col>
                </Row>

            </Container>
            <Footer/>
        </div>
    );
};
export default FotoGalerie;
